import * as React from 'react';
import { observer } from 'mobx-react';
import strings from 'owa-strings/owa-options-strings';
import getStore from '../store/store';
import { OptionDescription } from 'owa-options-controls';
import { format } from 'owa-strings';
import { Link } from 'office-ui-fabric-react/lib/Link';

const styles = require('./ExportMailboxStatus.scss');

export default observer(function ExportMailboxStatus(props: {}) {
    const { isExportMailboxRequestMade, downloadLink } = getStore();

    return (
        isExportMailboxRequestMade && (
            <div className={styles.statusDiv}>
                <OptionDescription className={styles.loadingStatus}>
                    {format(
                        strings.option_export_mailbox_status_label,
                        downloadLink
                            ? strings.option_export_mailbox_export_complete
                            : strings.option_export_mailbox_export_in_progress
                    )}
                </OptionDescription>
                {downloadLink && (
                    <Link href={downloadLink}>{strings.option_export_mailbox_download_link}</Link>
                )}
            </div>
        )
    );
});
